"use strict";

var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = _interopRequire(require("react"));

var classNames = _interopRequire(require("classnames"));

var Row = React.createClass({
  displayName: "Row",

  propTypes: {
    componentClass: React.PropTypes.node.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      componentClass: "div"
    };
  },

  render: function render() {
    var ComponentClass = this.props.componentClass;

    return React.createElement(
      ComponentClass,
      _extends({}, this.props, { className: classNames(this.props.className, "row") }),
      this.props.children
    );
  }
});

module.exports = Row;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/lib/Row.js
 ** module id = 74
 ** module chunks = 0
 **/